/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { StreamerBoxStreamerBoxDevicesRenameMutationRequest, StreamerBoxStreamerBoxDevicesRenameMutationResponse, StreamerBoxStreamerBoxDevicesRenamePathParams } from "../models/StreamerBoxStreamerBoxDevicesRename";

export function getStreamerBoxStreamerBoxDevicesRenameUrl(uuidOrId: StreamerBoxStreamerBoxDevicesRenamePathParams["uuidOrId"]) {
  const res = { method: 'POST', url: `/streamer-box/devices/${uuidOrId}/rename` as const }
  return res
}

/**
 * @description Renames the Balena device.
 * @summary Rename device
 * {@link /streamer-box/devices/:uuidOrId/rename}
 */
export async function streamerBoxStreamerBoxDevicesRename(uuidOrId: StreamerBoxStreamerBoxDevicesRenamePathParams["uuidOrId"], data: StreamerBoxStreamerBoxDevicesRenameMutationRequest, config: Partial<RequestConfig<StreamerBoxStreamerBoxDevicesRenameMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<StreamerBoxStreamerBoxDevicesRenameMutationResponse, ResponseErrorConfig<Error>, StreamerBoxStreamerBoxDevicesRenameMutationRequest>({ method : "POST", url : getStreamerBoxStreamerBoxDevicesRenameUrl(uuidOrId).url.toString(), data : requestData, ... requestConfig })
  return res.data
}